import { render, staticRenderFns } from "./bili_count.vue?vue&type=template&id=105bd92a&scoped=true"
import script from "./bili_count.vue?vue&type=script&lang=js"
export * from "./bili_count.vue?vue&type=script&lang=js"
import style0 from "./bili_count.vue?vue&type=style&index=0&id=105bd92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105bd92a",
  null
  
)

export default component.exports